import Plugin from './model.js'
import { deepGet, addToCollection } from '../shared/helper'

const initialTemplateState = {
  id: null,
  code: ''
}

const initialScriptState = {
  id: null,
  code: ''
}

const initialPhpState = {
  id: null,
  code: ''
}

const initialSchedulerState = {
  id: null,
  code: ''
}

const initialJsonState = {
  id: null,
  code: ''
}

const initialFileState = {
  id: null,
  name: '',
  path: null
}

export default {
  namespaced: true,
  state: {
    plugins: [],
    filteredCollection: [],
    current: new Plugin(),
    currentTemplate: initialTemplateState,
    currentScript: initialScriptState,
    currentPhp: initialPhpState,
    currentScheduler: initialSchedulerState,
    currentJson: initialJsonState,
    currentFile: initialFileState,
    files: []
  },
  getters: {
    getCollection: state => state.plugins,
    getFilteredCollection: state => state.filteredCollection,
    getById: state => (id) => state.plugins.find(plugin => plugin.id === id),
    getCurrent: state => state.current,
    getCurrentTemplate: state => state.currentTemplate,
    getCurrentScript: state => state.currentScript,
    getCurrentPhp: state => state.currentPhp,
    getCurrentScheduler: state => state.currentScheduler,
    getCurrentJson: state => state.currentJson,
    getFiles: state => state.files,
    getCurrentFile: state => state.currentFile
  },
  actions: {
    getCollection({ commit, getters, state }, payload) {
      return this.dispatch('get', {
        path: 'v1/plugins',
        ...payload
      }).then((res) => {

        const data = deepGet(res, 'body.data')
        if (data) {

          const models = data.map((plugin) => {
            commit('addPluginToCollection', { pluginData: plugin })
            return getters.getById(plugin.id)
          })

          commit('addPluginToFilteredCollection', models)

          return { data: models, meta: res.body.meta }
        }
        return res
      })
    },
    getTemplate ({ commit }, id) {
      return this.dispatch('get', {
        path: 'v1/plugins/' + id + '/template'
      }).then((res) => {
        commit('updateCurrentTemplate', res && res.body)
      })
    },
    getScript ({ commit }, id) {
      return this.dispatch('get', {
        path: 'v1/plugins/' + id + '/script'
      }).then((res) => {
        commit('updateCurrentScript', res && res.body)
      })
    },
    getPhp ({ commit }, id) {
      return this.dispatch('get', {
        path: 'v1/plugins/' + id + '/php'
      }).then((res) => {
        commit('updateCurrentPhp', res && res.body)
      })
    },
    getScheduler ({ commit }, id) {
      return this.dispatch('get', {
        path: 'v1/plugins/' + id + '/scheduler'
      }).then((res) => {
        commit('updateCurrentScheduler', res && res.body)
      })
    },
    getJson ({ commit }, id) {
      return this.dispatch('get', {
        path: 'v1/plugins/' + id + '/json'
      }).then((res) => {
        commit('updateCurrentJson', res && res.body)
      })
    },
    create({ commit, getters }, model) {
      return this.dispatch('post', {
        path: 'v1/plugins',
        data: model.getJSON()
      }).then((res) => {

        commit('addPluginToCollection', { pluginData: res.body && res.body.data })

        return getters.getById(res.body && res.body.data.id)
      })
    },
    createFolder({ commit, getters }, payload) {
      return this.dispatch('post', {
        path: 'v1/plugins/' + payload.id + '/files/',
        data: payload
      })
    },
    uploadFile({ commit, getters }, payload) {
      return this.dispatch('post', {
        path: 'v1/plugins/' + payload.id + '/files',
        data: payload.formData
      })
    },
    update({ commit, getters }, model) {
      return this.dispatch('put', {
        path: 'v1/plugins/' + model.id,
        data: model.getJSON()
      }).then((res) => {

        commit('addPluginToCollection', { pluginData: res.body && res.body.data })

        return getters.getById(res.body && res.body.data.id)
      })
    },
    updateTemplate (store, payload) {
      return this.dispatch('put', {
        path: 'v1/plugins/' + payload.id + '/template',
        data: payload
      })
    },
    updateScript (store, payload) {
      return this.dispatch('put', {
        path: 'v1/plugins/' + payload.id + '/script',
        data: payload
      })
    },
    updatePhp (store, payload) {
      return this.dispatch('put', {
        path: 'v1/plugins/' + payload.id + '/php',
        data: payload
      })
    },
    updateScheduler (store, payload) {
      return this.dispatch('put', {
        path: 'v1/plugins/' + payload.id + '/scheduler',
        data: payload
      })
    },
    updateJson (store, payload) {
      return this.dispatch('put', {
        path: 'v1/plugins/' + payload.id + '/json',
        data: payload
      })
    },
    deletePlugin({ commit }, id) {
      return this.dispatch('del', {
        path: 'v1/plugins/' + id
      }).then((res) => {

        commit('removePluginFromCollection', id)

        return res
      })
    },
    deleteFile({ commit }, payload) {
      let path = 'v1/plugins/' + payload.id + '/files'
      if (payload.directory) {
        path += payload.directory
      }
      return this.dispatch('del', { path })
    },
    getFiles ({ commit }, payload) {
      let path = 'v1/plugins/' + payload.id + '/files/'
      if (payload.directory) {
        path += payload.directory
      }
      return this.dispatch('get', { path })
        .then((res) => {
          const files = deepGet(res, 'body')
          commit('updateFiles', files)
          return files
        })
    },
    downloadFile ({ commit }, payload) {
      return this.dispatch('getWithOpts', {
        path: 'v1/plugins/' + payload.id + '/files/download/' + payload.file,
        opts: { responseType: 'arraybuffer' }
      })
    },
    sync({ commit, getters, state }) {
      return this.dispatch('get', {
        path: 'v1/plugins/sync'
      }).then((res) => {

        return res
      })
    }
  },
  mutations: {
    addPluginToCollection(state, { pluginData, opts }) {
      addToCollection(this, state.plugins, pluginData, Plugin, opts)
    },
    addPluginToFilteredCollection(state, data) {
      state.filteredCollection = state.filteredCollection.concat(data)
    },
    removePluginFromCollection(state, pluginId) {
      const index = state.plugins.findIndex(el => el.id === pluginId)

      if (index === -1) {
        console.warn(`Could not find/delete plugin ${pluginId}`)
        return
      }

      state.plugins.splice(index, 1)
    },
    clearCollection(state) {
      state.plugins = []
    },
    clearFilteredCollection(state) {
      state.filteredCollection = []
    },
    updateCurrent (state, plugin) {
      state.current = plugin
    },
    updateCurrentTemplate (state, template) {
      state.currentTemplate = template
    },
    updateCurrentScript (state, script) {
      state.currentScript = script
    },
    updateCurrentPhp (state, php) {
      state.currentPhp = php
    },
    updateCurrentScheduler (state, scheduler) {
      state.currentScheduler = scheduler
    },
    updateCurrentJson (state, json) {
      state.currentJson = json
    },
    resetCurrent (state) {
      state.current = new Plugin()
    },
    resetCurrentTemplate (state) {
      state.currentTemplate = initialTemplateState
    },
    resetCurrentScript (state) {
      state.currentScript = initialScriptState
    },
    resetCurrentPhp (state) {
      state.currentPhp = initialPhpState
    },
    resetCurrentScheduler (state) {
      state.currentScheduler = initialSchedulerState
    },
    updateCurrentFile (state, file) {
      state.currentFile = file
    },
    updateFiles (state, files) {
      state.files = files
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/plugin/store.js